import { SalesAndResourcesDistributorPortalsContent } from '../types/SalesAndResourcesDistributorPortals';

export function createSalesAndResourcesDistributorPortalsContentPlaceholder(): SalesAndResourcesDistributorPortalsContent {
    const emptyPlain = { kind: 'plainText' as const, key: '', content: '' };
    const emptyMulti = { kind: 'plainMultilineText' as const, key: '', content: '' };
    const emptyImage = { kind: 'image' as const, key: '', imageUrl: '' };
    const emptyExternalLink = {
        kind: 'externalLink' as const,
        key: '',
        linkText: '',
        linkUrl: '',
    };

    return {
        pageTitle: emptyPlain,
        pageSubtitle: emptyMulti,
        pageTitleBackgroundImage: emptyImage,
        yageoPortal: emptyExternalLink,
        kemetPortal: emptyExternalLink,
        pulsePortal: emptyExternalLink,
    };
}
